// extracted by css-extract-rspack-plugin
export default {"prompt":"dC2HQPBx4CaMIiKr","iconWrapper":"vQHYzHHYMBE1rlAw","text":"FcNxNzqZVoH3WP27","heading":"kn4k0XO2F6EG2q7B","body":"bhNRbvGIWIo_Ik9x"};